import { profileRequestHref } from "@fusiqo/vozqi-shared";

/**
 * THE ONE THING TO DO, on the profile's sign and on each of its items'
 * pages: «Pedir servicio», the profile's own request (`profileRequestHref`).
 * WhatsApp is the floating button's alone: one way to write per page.
 * Nothing for a trade without requests. `onRequest`
 * runs as the request opens: an item writes what is asked for into the
 * request's draft first.
 */
export function ProfileActions({
  token,
  requestLabel,
  onRequest,
}: {
  token: string | null;
  requestLabel: string;
  onRequest?: () => void;
}) {
  if (token === null) return null;
  return (
    <div className="profile-actions">
      {/* nofollow: the request form is reached from a link, never a search result (public/_headers says noindex on /c/*). */}
      <a className="profile-cta" href={profileRequestHref(token)} rel="nofollow" onClick={onRequest}>
        {requestLabel}
      </a>
    </div>
  );
}
